/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useParams, useHistory } from 'react-router-dom';
import {
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CCardFooter,
  CFormGroup,
  CLabel,
  CInput,
  CButton,
  CForm,
  CInputCheckbox,
} from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';

import 'react-confirm-alert/src/react-confirm-alert.css';
import { detailInquiry, upsertInquiry } from 'src/slices/InquirySlice';
import { resetData } from 'src/slices/InquiryItemSlice';
import { useTrans } from 'src/contexts/language';

const InquiryDetail = () => {
  const { t, language } = useTrans();
  const routeParams = useParams();
  const { id } = routeParams;
  const [openModalProject, setOpenModalProject] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const inquiryItem = useSelector(state => state.inquiryItem);
  const dispatch = useDispatch();
  const history = useHistory();
  const [validated, setValidated] = useState(false);

  const formik = useFormik({
    initialValues: {
      language,
      name: inquiryItem.name || '',
      email: inquiryItem.email || '',
      company: inquiryItem.company || '',
      address: inquiryItem.address || '',
      message: inquiryItem.message || '',
      status: inquiryItem.status || 0,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required(`${t('Vui lòng điền')} ${t('Tên')}`),
      email: Yup.string().required(`${t('Vui lòng điền')} ${t('Email')}`),
      company: Yup.string().required(`${t('Vui lòng điền')} ${t('Công ty')}`),
      address: Yup.string().required(`${t('Vui lòng điền')} ${t('Địa chỉ')}`),
      message: Yup.string().required(`${t('Vui lòng điền')} ${t('Tin nhắn')}`),
    }),
    onSubmit: async vals => {
      const res = await dispatch(
        upsertInquiry({
          id: id === 'create' ? '' : id,
          data: { ...vals },
        }),
      );
      if (res.payload === true) {
        history.push(`/inquiry`);
      }
    },
  });
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    setFieldValue,
    values, // use this if you want controlled components
    errors,
    initialValues,
  } = formik;
  const imageChange = e => {
    setSelectedImage(e.target.files[0]);
  };
  const logoChange = e => {
    setSelectedLogo(e.target.files[0]);
  };

  const setData = (name, value) => {
    setFieldValue(name, value);
  };

  const handleClean = e => {
    e.preventDefault();
    dispatch(resetData());
    setSelectedImage();
    history.push(`/inquiry`);
  };

  useEffect(() => {
    (async () => {
      if (id !== 'create') {
        await dispatch(detailInquiry(id));
      } else {
        dispatch(resetData());
        setSelectedImage();
      }
    })();
  }, [id]);

  return (
    <>
      <CForm
        action=""
        method="post"
        encType="multipart/form-data"
        className="form-horizontal"
        onSubmit={handleSubmit}
      >
        <CCard>
          <CCardHeader>{t('Tạo mới dịch vụ')}</CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="name">{t('Tên')}</CLabel>
                  <CInput
                    id="name"
                    name="name"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.name || ''}
                  />
                  {touched.name && errors.name ? (
                    <small className="text-danger">{t(errors.name)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="email">{t('Email')}</CLabel>
                  <CInput
                    id="email"
                    name="email"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.email || ''}
                  />
                  {touched.email && errors.email ? (
                    <small className="text-danger">{t(errors.email)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="company">{t('Công ty')}</CLabel>
                  <CInput
                    id="company"
                    name="company"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.company || ''}
                  />
                  {touched.company && errors.company ? (
                    <small className="text-danger">{t(errors.company)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="address">{t('Địa chỉ')}</CLabel>
                  <CInput
                    id="address"
                    name="address"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.address || ''}
                  />
                  {touched.address && errors.address ? (
                    <small className="text-danger">{t(errors.address)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="message">{t('Tin nhắn')}</CLabel>
                  <CInput
                    id="message"
                    name="message"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.message || ''}
                  />
                  {touched.message && errors.message ? (
                    <small className="text-danger">{t(errors.message)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="4">
                <CFormGroup variant="custom-checkbox" inline>
                  <CInputCheckbox
                    id="status"
                    name="status"
                    checked={values.status ? 1 : 0}
                    onChange={e => setData(e.target.name, values.status ? 0 : 1)}
                  />
                  <CLabel htmlFor="status">{t('Kích hoạt')}</CLabel>
                </CFormGroup>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="center">
            <CButton color="primary" style={{ marginRight: 10 }} type="submit">
              {t('Lưu')}
            </CButton>
            <CButton color="secondary" onClick={handleClean}>
              {t('Không')}
            </CButton>
          </CCardFooter>
        </CCard>
      </CForm>
      <style>
        {`
          .horizontal-slider {
            width: 100%;
            max-width: 700px;
            height: 10vh;
            margin: auto;
          }
          .horizontal-text {
            max-width: 700px;
            width: 100%;
            margin: auto;
            display: flex;
            justify-content: space-between;
          }
          .horizontal-text div {
            text-align: center;
          }
          .horizontal-text p {
            background-color: #fca432;
            padding: 7px;
            color: white;
            border-radius: 15px;
          }
          .example-thumb {
            cursor: pointer;
            position: absolute;
            z-index: 100;
            background: #ffffff;
            border: 5px solid #fca432;
            border-radius: 100%;
            display: block;
            box-shadow: 0 0 2px 0 rgb(0 0 0 / 44%);
          }
          .example-thumb.active {
            background-color: grey;
          }
          .example-track {
            position: relative;
            background: #ddd;
          }
          .example-track.example-track-0 {
            background: #fca432;
          }
          .horizontal-slider .example-track {
            top: 15px;
            height: 5px;
          }
          .horizontal-slider .example-thumb {
            top: 12px;
            width: 10px;
            outline: none;
            height: 10px;
            line-height: 38px;
          }
        `}
      </style>
    </>
  );
};

export default InquiryDetail;
